var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('horizontal-stepper',{attrs:{"locale":"fr","top-buttons":true,"steps":_vm.steps},on:{"completed-step":_vm.completedStep,"active-step":_vm.isStepActive}})}
var staticRenderFns = []

export { render, staticRenderFns }